interface SwitchInputProps {
  label: string;
  value: boolean;
  onChange: (e: any) => void;
  readOnly?: boolean; // Propriété pour rendre le composant en lecture seule
}

function SwitchInput({
  label,
  value,
  onChange,
  readOnly = false, // Valeur par défaut à false
}: SwitchInputProps) {
  // Gestionnaire d'événements conditionnel
  const handleChange = (e: any) => {
    if (!readOnly) {
      onChange(e);
    }
  };
  
  return (
    <div className="form-group mt-3 ms-3">
      <div className="d-flex align-items-center gap-2">
        <input
          className="checkbox-input switch-check-input"
          checked={value}
          type="checkbox"
          onChange={handleChange}
          style={readOnly ? { pointerEvents: 'none' } : undefined}
        />
        <div className="switch-label">{label}</div>
      </div>
    </div>
  );
}

export default SwitchInput;